import React from 'react'
import { Typography } from "@mui/material";
import { COLOR } from '../../constants';
import dayjs from 'dayjs';

function Note({note, index=0, padding='0px', captionTextSize='', textSize=''}) {
    let bgColor = (index%2 === 0) ? COLOR.odd : COLOR.even;
    let date = '';
    let time='';
    if(note.date){
        let datetime = note.date.split(" ");
        date = datetime[0];
        time = datetime[1];
    }

  return (
    <div 
        style={{
            marginBottom:'15px',
            "&::WebkitScrollbar": {
                width: 6
            },
            "&::WebkitScrollbarTrack": {
                backgroundColor: "white"
            },
            "&::WebkitScrollbarThumb": {
                backgroundColor: "#ccc",
                borderRadius: 2
            }
        }} 
            
            key={note.id}
            >
        <div style={{padding:`${padding}`, fontFamily: 'Open Sans', backgroundColor:`${bgColor}`}}>
            <Typography component={'div'} sx={{fontStyle: 'italic', fontWeight:500, fontSize:`${captionTextSize}`}}>
                {dayjs(date).format('MM/DD/YYYY')} at {time} added by {note.addedBy} 
            </Typography>
            <Typography component={'span'} sx={{ fontSize:`${textSize}`, whiteSpace: "pre-line"}}> 
                {note.message}
            </Typography>
        </div>
    </div>
  )
}

export default Note